export class Observable<T> {
  #subscribe: SubscribeFn<T>;

  constructor(subscribe: SubscribeFn<T>) {
    this.#subscribe = subscribe;
  }

  subscribe(next: NextFn<T>):Subscription {
    const teardown = this.#subscribe(new Subscriber(next));

    return new Subscription(() => {
      teardown?.();
    });
  }
}

export class Subscriber<T> {
  #next:NextFn<T>;

  constructor(next: NextFn<T>) {
    this.#next = next
  }

  next(value: T) {
    this.#next(value);
  }
}

export class Subscription {
  #unsubscribe?: TeardownFn;

  constructor(unsubscribe?: TeardownFn){
    this.#unsubscribe = unsubscribe;
  }

  unsubscribe() {
    this.#unsubscribe?.();
  }
}

export type SubscribeFn<T> = (subscriber:Subscriber<T>) => TeardownFn | void;
export type TeardownFn = () => void;
export type NextFn<T> = (vallue:T) => void;